/**
 * Maps phone country calling codes to their default currency.
 * Used to auto-detect the default currency when creating a store,
 * based on the logged-in user's phone number.
 */
const phoneToCurrency = {
  "+250": "RWF", // Rwanda
  "+254": "KES", // Kenya
  "+256": "UGX", // Uganda
  "+255": "TZS", // Tanzania
  "+243": "CDF", // DR Congo
  "+257": "BIF", // Burundi
  "+211": "SSP", // South Sudan
  "+251": "ETB", // Ethiopia
  "+234": "NGN", // Nigeria
  "+233": "GHS", // Ghana
  "+27": "ZAR", // South Africa
  "+237": "XAF", // Cameroon
  "+225": "XOF", // Côte d'Ivoire
  "+221": "XOF", // Senegal
  "+20": "EGP", // Egypt
  "+212": "MAD", // Morocco
  "+216": "TND", // Tunisia
  "+213": "DZD", // Algeria
  "+260": "ZMW", // Zambia
  "+263": "ZWL", // Zimbabwe
  "+265": "MWK", // Malawi
  "+258": "MZN", // Mozambique
  "+244": "AOA", // Angola
  "+226": "XOF", // Burkina Faso
  "+223": "XOF", // Mali
  "+227": "XOF", // Niger
  "+228": "XOF", // Togo
  "+229": "XOF", // Benin
  "+1": "USD", // USA / Canada
  "+44": "GBP", // United Kingdom
  "+33": "EUR", // France
  "+49": "EUR", // Germany
  "+34": "EUR", // Spain
  "+39": "EUR", // Italy
  "+31": "EUR", // Netherlands
  "+32": "EUR", // Belgium
  "+351": "EUR", // Portugal
  "+353": "EUR", // Ireland
  "+43": "EUR", // Austria
  "+358": "EUR", // Finland
  "+30": "EUR", // Greece
  "+86": "CNY", // China
  "+91": "INR", // India
  "+81": "JPY", // Japan
  "+82": "KRW", // South Korea
  "+62": "IDR", // Indonesia
  "+60": "MYR", // Malaysia
  "+63": "PHP", // Philippines
  "+66": "THB", // Thailand
  "+84": "VND", // Vietnam
  "+65": "SGD", // Singapore
  "+971": "AED", // UAE
  "+966": "SAR", // Saudi Arabia
  "+974": "QAR", // Qatar
  "+973": "BHD", // Bahrain
  "+968": "OMR", // Oman
  "+962": "JOD", // Jordan
  "+961": "LBP", // Lebanon
  "+90": "TRY", // Turkey
  "+55": "BRL", // Brazil
  "+52": "MXN", // Mexico
  "+57": "COP", // Colombia
  "+56": "CLP", // Chile
  "+54": "ARS", // Argentina
  "+51": "PEN", // Peru
  "+61": "AUD", // Australia
  "+64": "NZD", // New Zealand
  "+7": "RUB", // Russia
  "+380": "UAH", // Ukraine
  "+48": "PLN", // Poland
  "+46": "SEK", // Sweden
  "+47": "NOK", // Norway
  "+45": "DKK", // Denmark
  "+41": "CHF", // Switzerland
};

/**
 * Get the default currency code based on a phone number.
 * Tries longest prefix match first (e.g. +971 before +97).
 * @param {string} phoneNumber - The user's phone number (e.g. "+250781234567")
 * @param {string} fallback - Fallback currency if no match found (default: "RWF")
 * @returns {string} Currency code (e.g. "RWF")
 */
export function getCurrencyFromPhone(phoneNumber, fallback = "RWF") {
  if (!phoneNumber) return fallback;

  // Try longest prefix first for accurate matching
  const prefixes = Object.keys(phoneToCurrency).sort(
    (a, b) => b.length - a.length,
  );

  for (const prefix of prefixes) {
    if (phoneNumber.startsWith(prefix)) {
      return phoneToCurrency[prefix];
    }
  }

  return fallback;
}

export default phoneToCurrency;
